import {Component} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DISTRIBUTION_LINKS} from '../../../models/distribution-links';
import {Router} from '@angular/router';
import {DeviceOs} from '../../../models/device-os';
import {WindowProvider} from '../../../helpers/window-provider';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@Component({
    selector: 'app-qr-download-and-login',
    templateUrl: './qr-download-and-login.component.html',
    styleUrls: ['./qr-download-and-login.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule]
})
export class QrDownloadAndLoginComponent {
  public distributionLinks = DISTRIBUTION_LINKS;
  public deviceOss = DeviceOs;

  constructor(private deviceService: DeviceDetectorService, private router: Router, private windowProvider: WindowProvider) {
    const link = DISTRIBUTION_LINKS[this.deviceService.os];

    if (link) {
      this.windowProvider.get().location.href = link;
    } else {
      this.router.navigate(['/']).then();
    }
  }
}
